import { useState, useEffect } from 'react';

import { getUser, logoutUser, User } from '../services/user';

const useUser = (): [User | undefined] => {
  const [user, setUser] = useState<User>();
  const [error, setError] = useState(false);

  useEffect(() => {
    if (error) {
      logoutUser();
    }
  }, [error]);

  useEffect(() => {
    void (async (): Promise<void> => {
      try {
        const userData = await getUser();
        setUser(userData);
      } catch (err) {
        setError(true);
      }
    })();
  }, []);

  return [user];
};

export default useUser;
